"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaSelectionButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function AreaSelectionButton({ iconName, label, onClick, selected, }) {
    return ((0, jsx_runtime_1.jsxs)(Button, { onClick: onClick, "aria-pressed": selected, "data-e2e": 'AreaSelectionButton_Button', children: [(0, jsx_runtime_1.jsx)(ButtonIcon, { name: iconName, selected: selected, "data-e2e": 'AreaSelectionButton_ButtonIcon' }), (0, jsx_runtime_1.jsx)(ButtonLabel, { selected: selected, "data-e2e": 'AreaSelectionButton_ButtonLabel', children: label })] }));
}
exports.AreaSelectionButton = AreaSelectionButton;
const Button = (0, ui_1.withA11y)(styled_components_1.default.button `
  display: flex;

  width: 100%;
  max-width: 146px;
  height: 44px;

  margin: 0;
  padding: 0;

  color: inherit;
  font: inherit;

  text-align: center;

  background-color: transparent;
  border: none;

  cursor: pointer;

  user-select: none;
`);
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 8em;
  height: 4em;
  margin-left: 4px;
`;
const ButtonLabel = styled_components_1.default.div `
  position: relative;
  top: -4px;

  display: block;
  width: 100%;
  margin: auto;
  padding-right: 8px;

  color: ${({ selected, theme }) => selected ? theme.text : theme.textSecondary};

  font-weight: ${({ selected }) => (selected ? 600 : 400)};
  font-size: 11px;
  text-align: left;
`;
